import { AppSidebarLayout } from "../layouts";
import { EndpointsByOrg } from "../shared";

export const EndpointsPage = () => {
  return (
    <AppSidebarLayout>
      <EndpointsByOrg />
    </AppSidebarLayout>
  );
};
